module.exports = __webpack_public_path__ + "assets/img/acbe349efec007b4819b4d0a395bb696.png";